import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ReportesService } from 'app/services/reportes/reportes.service';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS  } from '@angular/material';
import * as XLSX from 'xlsx';
import { FiltrosRepComercial } from 'app/models/FiltrosRepComercial';
import { SecurityService } from 'app/services/security/security.service';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { FiltrosRepContabilidad } from 'app/models/FiltrosRepContabilidad';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-listar-facturas-generadas',
  templateUrl: './listar-facturas-generadas.component.html',
  styleUrls: ['./listar-facturas-generadas.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesStatus,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListarFacturasGeneradasComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('TABLE', { static: true }) table: ElementRef;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns = ['RUC_CLIENTE', 'RAZON_SOCIAL', 'NUMERO', 'MONEDA', 'MONTO_GRAVADO', 'MONTO_NO_GRAVADO'
  , 'IGV', 'FACTURA_TOTAL', 'ESTADO_FACTURA', 'FECHA_EMISION', 'ID_OPERACION','FECHA_OPERACION'];
  abrirDetalleConciliacion: boolean = false;
  loading: boolean;
  planillas: any = [];
  dataReporte: any = [];
  dataSource: any;
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  arrListaAccesos: any[] = [];
  subRepContabilidad: Subscription = new Subscription();
  DTOFiltrosRepContabilidad: FiltrosRepContabilidad = new FiltrosRepContabilidad();
  arrListaRoles: any[] = [];
  usuarioLogueado: any;
  usuarioFiltro: any;
  rolUsuario: any;
  loadingUser: boolean;
  readonly ROL_ADMIN: string = 'administrador';
  readonly ROL_COMERCIAL: string = 'administrador';
  readonly ROL_JEFATURA: string = 'jefe';
  readonly ROL_GERENCIA: string = 'gerencia';
  subLista: Subscription[] = [];
  subRol: Subscription = new Subscription();
  subAcceso: Subscription = new Subscription();
  subUser: Subscription = new Subscription();
  constructor(private reporteService: ReportesService,
    private securityService: SecurityService,
    private msgTitulos: MessagesTitles,
    private datePipe: DatePipe,
    private msgStatus: MessagesStatus) { }

  ngOnInit() {
    this.usuarioLogueado = JSON.parse(sessionStorage.getItem('UserActive'));
    this.obtenerListaAccesos();
    this.ListadoRepContabilidad();
  }
  obtenerListaAccesos() {
    this.subRol = this.securityService.ObtenerListaRoles(this.usuarioLogueado.id_empresa).subscribe(
      (resRoles: any) => {
        this.arrListaRoles = resRoles;
        this.rolUsuario = this.arrListaRoles.find(r => r.id_roles == this.usuarioLogueado.id_roles);
        this.rolUsuario.Nombre = this.rolUsuario.Nombre.toLowerCase();

        this.subAcceso = this.securityService.ObtenerListaAccesos().subscribe(
          (resAccesos: any) => {
            this.arrListaAccesos = resAccesos;
            if (this.rolUsuario.Nombre.startsWith(this.ROL_JEFATURA) || this.rolUsuario.Nombre == this.ROL_GERENCIA || this.rolUsuario.Nombre == this.ROL_ADMIN) {
              this.arrListaAccesos = this.arrListaAccesos.filter(a => a.id_roles_dsc.toLowerCase() == this.ROL_COMERCIAL);
            } else if (this.rolUsuario.Nombre == this.ROL_COMERCIAL) {
              this.arrListaAccesos = this.arrListaAccesos.filter(a => a.id_user == this.usuarioLogueado.id_user);
            } else {
              this.arrListaAccesos = [];
            }
          },
          (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.error instanceof ErrorEvent) {
              console.error("Error Event");
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "LISTA ACCESOS NO OBTENIDA. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          }
        );

        this.subLista.push(this.subAcceso);

      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA ROLES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subRol);
  }
  ListadoRepContabilidad(){
    this.loading = true;
    this.DTOFiltrosRepContabilidad.Tipo = 'facturas_generadas';
    this.subRepContabilidad = this.securityService.FiltroListadoRepContabilidad(this.DTOFiltrosRepContabilidad, this.datePipe.transform(this.fechaD, 'yyyy-MM-dd'), this.datePipe.transform(this.fechaH, 'yyyy-MM-dd')).subscribe(
      res => {
        this.dataReporte = res;
        this.dataSource = new MatTableDataSource(this.dataReporte);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
        this.securityService.dataBuffer = this.dataReporte;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA REPORTE NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }
  seleccionarUsuario(event) {
    this.loadingUser = true;
    Swal.fire({
      title: 'Espere',
      text: 'Obteniendo datos del usuario seleccionado',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    let TipoUsuario = "COM";
    this.subUser = this.securityService.ObtenerUsuarios(TipoUsuario).subscribe(
      res => {

        this.usuarioFiltro = res;
        this.usuarioFiltro = this.usuarioFiltro.filter(u => u.Nombre == event);
        this.DTOFiltrosRepContabilidad.Usuario = this.usuarioFiltro[0].Usuario;
        this.loadingUser = false;
        if (this.loadingUser == false) {
          Swal.close();
        }

      },
      (err: HttpErrorResponse) => {

        this.loadingUser = false;
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "DATOS DEL USUARIO NO OBTENIDOS. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subUser);
  }
  ExportTOExcel() {
    let fecha = new Date();
    const headerStyle: any = this.securityService.headerStyle;
    const data = this.securityService.dataBuffer;
    const footer = this.securityService.footerStyle;
    const headers = this.securityService.displayedColumns;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Data');
    const headersString: any = [];
    if(this.securityService.type_reporte == 'especial_1'){
       // Add data
       let count=2;
       worksheet.mergeCells(String('B2:C2'));
       const rows0=worksheet.getRow(count);
       rows0.getCell(2).value=' Desde: '+data[0].fecha_inicio+ '  Hasta: '+data[0].fecha_fin;
       rows0.getCell(2).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb:  '80D069'}
      };      
      rows0.getCell(2).alignment = { vertical: 'middle', horizontal: 'center' };

      count++;
      count++;

       data.forEach((item,index) => {
         const rows=worksheet.getRow(count);
         headers.forEach((header,ind) => {       

            if((ind+2)==5){
              rows.getCell(ind+2).value=item[header]*1;
              rows.getCell(ind + 2).numFmt='[$$-es-US]#,##0.00';
            }else{
              rows.getCell(ind+2).value=item[header];
            }
            rows.getCell(ind + 2).border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };
            rows.getCell(ind + 2).fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb:  'E3AA80'}
            };
            rows.getCell(ind + 2).font = {
              name: 'Calibri',
              color: { argb: '000000' },
              bold: true,
              size: 12
            }

        });      
        count++;
        count++;
        const rows2=worksheet.getRow(count);
        rows2.getCell(3).value='INVERSIONISTAS';
        rows2.getCell(4).value='ANEXO'; 
        rows2.getCell(5).value='VALOR INVERSION'; 
        rows2.getCell(6).value='RENDIMIENTO NETO'; 
        
        rows2.getCell(3).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }; 
        rows2.getCell(4).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }; 
        rows2.getCell(5).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }; 
        rows2.getCell(6).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }; 
     
        rows2.getCell(3).font = {
          name: 'Calibri',
          color: { argb: '000000' },
          bold: true,
          size: 12
        }
        rows2.getCell(4).font = {
          name: 'Calibri',
          color: { argb: '000000' },
          bold: true,
          size: 12
        }
        rows2.getCell(5).font = {
          name: 'Calibri',
          color: { argb: '000000' },
          bold: true,
          size: 12
        }
        rows2.getCell(6).font = {
          name: 'Calibri',
          color: { argb: '000000' },
          bold: true,
          size: 12
        }
        count++;
        item['INVERSIONISTAS'].forEach(element => {           
          const rows3=worksheet.getRow(count);
          rows3.getCell(3).value=element.Nombre_Fondo;
          rows3.getCell(4).value=element.numeracion;
          rows3.getCell(5).value=element.Valor_Inversion*1;
          rows3.getCell(6).value=element.rendimiento_neto*1;
          
          rows3.getCell(5).numFmt='[$$-es-US]#,##0.00';
          rows3.getCell(6).numFmt='[$$-es-US]#,##0.00';
          count++;
        });           
       count++;
       count++;
     });
     
     worksheet.getColumn(1).width = 10;
     worksheet.getColumn(2).width = 25;
     worksheet.getColumn(3).width = 55;
     worksheet.getColumn(4).width = 20;
     worksheet.getColumn(5).width = 30;
     worksheet.getColumn(6).width = 30;
      // Generate Excel file
      workbook.xlsx.writeBuffer().then((buffer: any) => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Reporte_Vencimiento_Operaciones_Inversionistas_' + this.datePipe.transform(fecha, 'dd-MM-yyyy') + '.xlsx');
      });
    }else{
      headers.forEach(element => {
        headersString.push(element.split("_").join(' '));
      });

      var i = 0;
      headerStyle.forEach((element, index) => {
        if (element.cells) {
          worksheet.mergeCells(String(element.cells));
        }
        if (element.title) {
          worksheet.getCell(element.cell).value = element.title;
        } else {
          worksheet.getCell(element.cell).value = headersString[i];
          i++;
        }
        worksheet.getColumn(index + 1).width = 20;
        worksheet.getCell(element.cell).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        worksheet.getCell(element.cell).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: element.fgColor }
        };
        worksheet.getCell(element.cell).font = {
          name: 'Calibri',
          color: { argb: element.color },
          bold: true,
          size: 11
        }
        worksheet.getCell(element.cell).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

        // Add data
        let count=3;
        data.forEach((item,index) => {
          const rows=worksheet.getRow(count);
          headers.forEach((header,ind) => {
            if(String(item[header]).includes('.')){
              if(
                String(item[header]).includes('.pe') ||
                String(item[header]).includes('.com') ||
                String(item[header]).includes('CIA.') ||
                String(item[header]).includes('LTDA.') ||
                String(item[header]).includes('S.R.L') ||
                String(item[header]).includes('S.A') ||
                String(item[header]).includes('S.C.R.L') ||
                String(item[header]).includes('@')
              ){
                rows.getCell(ind+1).value=item[header];
              }else{
                rows.getCell(ind+1).value=Number(item[header]);
              }
          }else{
            rows.getCell(ind+1).value=item[header];
          }
          rows.getCell(ind + 1).border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        });
        count++;
      });
      //Add Footer
      footer.forEach((item, index) => {
        const rows = worksheet.getRow(data.length + 3);
        rows.getCell(index + 1).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: item.fgColor }
        };
        rows.getCell(index + 1).border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        if (item.content) {
          rows.getCell(index + 1).value = item.content;
        }
        if (item.formula && data.length > 0) {
          rows.getCell(index + 1).value = { formula: `${item.formula}(${item.col}3:${item.col}${data.length + 2})`, date1904: false };
        }
        rows.getCell(index + 1).alignment = { vertical: 'middle', horizontal: 'center' };
        rows.getCell(index + 1).font = {
          name: 'Calibri',
          color: { argb: item.color },
          bold: true,
          size: 11
        }
      });

      // Generate Excel file
      workbook.xlsx.writeBuffer().then((buffer: any) => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Reporte_Faktorlab_' + this.datePipe.transform(fecha, 'dd-MM-yyyy') + '.xlsx');
      });
    }
    


  }
}
